document.addEventListener("DOMContentLoaded", () => {
  // notify弹出弹窗
  $(".holiday-pre-order .product-notify-btn").click(function () {
    $(".holiday-pre-order .notify-window").css("display", "flex");
  });

  //  弹窗关闭按钮
  $(".close-icon").click(function () {
    $(this).parent(".notify-window").css("display", "none");
  });
  //  弹窗关闭按钮

  // code copy
  $(".code-wrapper .copy-btn").click(function () {
    let code = $(this).parent().find(".code-text").text();
    let nodeEl = $(this);
    navigator.clipboard
      .writeText(code)
      .then(function () {
        nodeEl.text("✔");
        setTimeout(function () {
          nodeEl.text("COPY");
        }, 3000);
      })
      .catch((err) => {
        alert("copy error!");
      });
  });

  // 价格汇率
  const priceElements = document.querySelectorAll('[data-format="true"]');
  // 处理discount-price
  priceElements.forEach((item) => {
    const discountPrice = item.querySelector('.discount-price').dataset.price;
    const originalPrice = item.querySelector('.original-price').dataset.price;

    const formattedDiscountPrice = currencyFormatter.formats.formatMoney(
      discountPrice * Shopify.currency.rate,
      window.moneyFormat.format_with_currency
    );
    const formattedOriginalPrice = currencyFormatter.formats.formatMoney(
      originalPrice * Shopify.currency.rate,
      window.moneyFormat.format_with_currency
    );

    item.querySelector('.discount-price').textContent = formattedDiscountPrice;
    item.querySelector('.original-price').textContent = formattedOriginalPrice;
    
    // console.log("汇率：", Shopify.currency.rate);
    // console.log("更新后的折扣价格：", formattedDiscountPrice);
    // console.log("更新后的原价：", formattedOriginalPrice);
  })
});
